import axios from "axios";
import { getToken } from "../../../utils/auth-storage";

// Create a separate axios instance for nestjsx-crud without baseURL
const axiosInstance = axios.create({
  timeout: 30000,
  headers: {
    "Content-Type": "application/json",
  },
});

// Interceptor to add auth token
axiosInstance.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token && config.headers) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor for response errors
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    if (error.response) {
      const { status } = error.response;

      if (status === 401 || status === 403) {
        if (window.location.pathname !== "/login") {
          localStorage.removeItem("accessToken");
          setTimeout(() => {
            window.location.href = "/login";
          }, 100);
        }
      }
    }

    return Promise.reject(error);
  }
);

export { axiosInstance };
